var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisualizationHelpIcon = function SvgVisualizationHelpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 40,
    fill: "none",
    viewBox: "0 0 80 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.148,
    height: 27.943,
    x: 12.729,
    y: 7.27,
    fill: "#5899DA",
    rx: 2.074
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.148,
    height: 12.701,
    x: 23.788,
    y: 22.51,
    fill: "#ED4A7B",
    rx: 2.074
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.148,
    height: 21.476,
    x: 33.973,
    y: 13.312,
    fill: "#FB9341",
    rx: 2.074
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.148,
    height: 10.161,
    x: 44.527,
    y: 25.051,
    fill: "#F4B400",
    rx: 2.074
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.148,
    height: 16.363,
    x: 55.123,
    y: 18.426,
    fill: "#12A4B4",
    rx: 2.074
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.148,
    height: 8.891,
    x: 66.647,
    y: 26.32,
    fill: "#945FCF",
    rx: 2.074
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    strokeLinecap: "round",
    d: "M8.637 1v36a2 2 0 0 0 2 2H75M8.636 5.915H5M8.636 15.414H5M8.636 24.587H5M8.636 33.759H5"
  })));
};
export default SvgVisualizationHelpIcon;